import React from 'react'
import HeroStat from './HeroStat'
import HeroStatSection from './HeroStatSection'

/*
 *   NEED TO REPLACE STRINGS WITH CONSTANTS FROM CONSTANTS.js
 */

const HeroSnapshotFront = ({ hero }) => {
    return (
        <>
            <HeroStatSection title='Stats'>
                <HeroStat name='STR' value={hero.strength} main={hero.statBoost1 === 'Strength'} minor={hero.statBoost2 === 'Strength'} />
                <HeroStat name='AGI' value={hero.agility} main={hero.statBoost1 === 'Agility'} minor={hero.statBoost2 === 'Agility'} />
                <HeroStat name='END' value={hero.endurance} main={hero.statBoost1 === 'Endurance'} minor={hero.statBoost2 === 'Endurance'} />
                <HeroStat name='WIS' value={hero.wisdom} main={hero.statBoost1 === 'Wisdom'} minor={hero.statBoost2 === 'Wisdom'} />
                <HeroStat name='DEX' value={hero.dexterity} main={hero.statBoost1 === 'Dexterity'} minor={hero.statBoost2 === 'Dexterity'} />
                <HeroStat name='VIT' value={hero.vitality} main={hero.statBoost1 === 'Vitality'} minor={hero.statBoost2 === 'Vitality'} />
                <HeroStat name='INT' value={hero.intelligence} main={hero.statBoost1 === 'Intelligence'} minor={hero.statBoost2 === 'Intelligence'} />
                <HeroStat name='LCK' value={hero.luck} main={hero.statBoost1 === 'Luck'} minor={hero.statBoost2 === 'Luck'} />
            </HeroStatSection>
            <HeroStatSection className='profession-stat-section' title='Professions'>
                <HeroStat name='Mining' value={hero.mining} main={hero.profession === 'mining'} />
                <HeroStat name='Fishing' value={hero.fishing} main={hero.profession === 'fishing'} />
                <HeroStat name='Gardening' value={hero.gardening} main={hero.profession === 'gardening'} />
                <HeroStat name='Foraging' value={hero.foraging} main={hero.profession === 'foraging'} />
            </HeroStatSection>
        </>
    )
}

export default HeroSnapshotFront